import { ProductSourceDto } from "definitions/product-storage";
import { SOURCE_LIST, SourceCode } from "src/constants/sources";

export type PlatformAvailability = {
  platforms: SourceCode[];
  unavailable: SourceCode[];
};

export const getPlatformAvailability = (
  sources: ProductSourceDto[] | undefined,
  loadableSources: SourceCode[],
): PlatformAvailability => {
  const platforms = SOURCE_LIST.map(({ code }) => code).filter((code) =>
    sources?.some((source) => source.source === code),
  );

  return {
    platforms,
    unavailable: platforms.filter((code) => !loadableSources.includes(code)),
  };
};
